var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.bigtitle,
        okText: "确认",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      !_vm.param.disabled
        ? _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.formState,
                rules: _vm.rules,
                "label-col": { span: 8 },
                "wrapper-col": { span: 16 },
              },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构代码", prop: "code" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "code", $$v)
                              },
                              expression: "formState.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "检测机构名称", prop: "name" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "name", $$v)
                              },
                              expression: "formState.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "检测机构类型", prop: "type" } },
                        [
                          _c("a-ext-local-dic-select", {
                            attrs: { dicKey: "CheckerType" },
                            model: {
                              value: _vm.formState.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "type", $$v)
                              },
                              expression: "formState.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "社会信用代码", prop: "publicCode" },
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.publicCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "publicCode", $$v)
                              },
                              expression: "formState.publicCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "所属区域", prop: "xzqh" } },
                        [
                          _c("a-ext-dist-picker-qu", {
                            model: {
                              value: _vm.formState.xzqh,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "xzqh", $$v)
                              },
                              expression: "formState.xzqh",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构联系方式", prop: "orgTel" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.orgTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "orgTel", $$v)
                              },
                              expression: "formState.orgTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "法定代表人", prop: "bossName" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.bossName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "bossName", $$v)
                              },
                              expression: "formState.bossName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "法人身份证", prop: "bossCode" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.bossCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "bossCode", $$v)
                              },
                              expression: "formState.bossCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 4 },
                            wrapperCol: { span: 20 },
                            label: "机构所在地址",
                            prop: "address",
                          },
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "address", $$v)
                              },
                              expression: "formState.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "电子邮箱", prop: "email" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "email", $$v)
                              },
                              expression: "formState.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "传真", prop: "fax" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.fax,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "fax", $$v)
                              },
                              expression: "formState.fax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 4 },
                            wrapperCol: { span: 20 },
                            label: "邮编",
                            prop: "mailCode",
                          },
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.mailCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "mailCode", $$v)
                              },
                              expression: "formState.mailCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "负责人", prop: "ceoName" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.ceoName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "ceoName", $$v)
                              },
                              expression: "formState.ceoName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "负责人电话", prop: "ceoTel" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.ceoTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "ceoTel", $$v)
                              },
                              expression: "formState.ceoTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "联系人", prop: "connectName" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.connectName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "connectName", $$v)
                              },
                              expression: "formState.connectName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "联系人电话", prop: "connectTel" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.connectTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "connectTel", $$v)
                              },
                              expression: "formState.connectTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量负责人", prop: "qaName" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.qaName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "qaName", $$v)
                              },
                              expression: "formState.qaName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量负责人电话", prop: "qaTel" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.qaTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "qaTel", $$v)
                              },
                              expression: "formState.qaTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量认定证书", prop: "jlrdzs" } },
                        [
                          _c("a-ext-upload", {
                            model: {
                              value: _vm.formState.jlrdzs,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "jlrdzs", $$v)
                              },
                              expression: "formState.jlrdzs",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构考核证书", prop: "jgkhzs" } },
                        [
                          _c("a-ext-upload", {
                            model: {
                              value: _vm.formState.jgkhzs,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "jgkhzs", $$v)
                              },
                              expression: "formState.jgkhzs",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "a-form-model",
            {
              attrs: {
                model: _vm.formState,
                rules: _vm.rules,
                "label-col": { span: 8 },
                "wrapper-col": { span: 16 },
              },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构代码", prop: "code" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "code", $$v)
                              },
                              expression: "formState.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "检测机构名称", prop: "name" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "name", $$v)
                              },
                              expression: "formState.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "检测机构类型", prop: "type" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "type", $$v)
                              },
                              expression: "formState.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "社会信用代码", prop: "publicCode" },
                        },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.publicCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "publicCode", $$v)
                              },
                              expression: "formState.publicCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "所属区域", prop: "xzqh" } },
                        [
                          _c("a-ext-bold-a", {
                            attrs: { value: _vm.formState.regionName },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构联系方式", prop: "orgTel" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.orgTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "orgTel", $$v)
                              },
                              expression: "formState.orgTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "法定代表人", prop: "bossName" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.bossName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "bossName", $$v)
                              },
                              expression: "formState.bossName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "法人身份证", prop: "bossCode" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.bossCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "bossCode", $$v)
                              },
                              expression: "formState.bossCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 4 },
                            wrapperCol: { span: 20 },
                            label: "机构所在地址",
                            prop: "address",
                          },
                        },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "address", $$v)
                              },
                              expression: "formState.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "电子邮箱", prop: "email" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "email", $$v)
                              },
                              expression: "formState.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "传真", prop: "fax" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.fax,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "fax", $$v)
                              },
                              expression: "formState.fax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 4 },
                            wrapperCol: { span: 20 },
                            label: "邮编",
                            prop: "mailCode",
                          },
                        },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.mailCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "mailCode", $$v)
                              },
                              expression: "formState.mailCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "负责人", prop: "ceoName" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.ceoName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "ceoName", $$v)
                              },
                              expression: "formState.ceoName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "负责人电话", prop: "ceoTel" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.ceoTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "ceoTel", $$v)
                              },
                              expression: "formState.ceoTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "联系人", prop: "connectName" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.connectName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "connectName", $$v)
                              },
                              expression: "formState.connectName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "联系人电话", prop: "connectTel" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.connectTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "connectTel", $$v)
                              },
                              expression: "formState.connectTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量负责人", prop: "qaName" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.qaName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "qaName", $$v)
                              },
                              expression: "formState.qaName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量负责人电话", prop: "qaTel" } },
                        [
                          _c("a-ext-bold-a", {
                            model: {
                              value: _vm.formState.qaTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "qaTel", $$v)
                              },
                              expression: "formState.qaTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "质量认定证书", prop: "jlrdzs" } },
                        [
                          _c("a-ext-upload", {
                            attrs: { disabled: _vm.param.disabled },
                            model: {
                              value: _vm.formState.jlrdzs,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "jlrdzs", $$v)
                              },
                              expression: "formState.jlrdzs",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "机构考核证书", prop: "jgkhzs" } },
                        [
                          _c("a-ext-upload", {
                            attrs: { disabled: _vm.param.disabled },
                            model: {
                              value: _vm.formState.jgkhzs,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "jgkhzs", $$v)
                              },
                              expression: "formState.jgkhzs",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }